import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { SearchResultComponent } from 'src/app/components/search/search.result.component';

const routes: Routes = [
    {
        path: '',
        component: SearchResultComponent,
        data: { reuse: true }
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class SearchRoutingModule { }
